Ext.define('SA.PageHeader', {
    alias: 'widget.page-header',
    extend: 'Ext.Component',

    baseCls: 'sa-page-header',

    tpl: [
        '<div class="sa-page-header-project-name-wrapper">',
            '<div id="project-label-{id}" class="sa-page-header-project-name-label">Current Project:</div>',
            '<h1 class="sa-page-header-project-name" aria-labelledby="project-label-{id}">{projectName:htmlEncode}</h1>',
        '</div>',
        '<button type="button" class="sa-page-header-button sa-page-header-new-button" aria-label="Create New Project">',
            '<svg aria-hidden="true" class="sa-page-header-button-icon"><use href="#sa-icon-new-project"></use></svg>',
            'New Project',
        '</button>',
        '<div class="sa-page-header-separator" aria-hidden="true"></div>',
        '<button type="button" class="sa-page-header-button sa-page-header-open-button" aria-label="Open Existing Project" aria-expanded="false">',
            '<svg aria-hidden="true" class="sa-page-header-button-icon"><use href="#sa-icon-open-project"></use></svg>',
            'Open Project',
        '</button>',
        '<div class="sa-page-header-separator" aria-hidden="true"></div>',
        '<button type="button" class="sa-page-header-button sa-page-header-manage-button<tpl if="manageActive"> sa-page-header-button-active</tpl>" aria-label="Manage Project Settings">',
            '<svg aria-hidden="true" class="sa-page-header-button-icon"><use href="#sa-icon-manage-project"></use></svg>',
            'Project Settings',
        '</button>',
        '<div class="sa-page-header-separator" aria-hidden="true"></div>',
        '<button type="button" class="sa-page-header-button sa-page-header-notifications-button sa-page-header-notifications-button-hidden" aria-label="Notifications">',
            '<svg aria-hidden="true" class="sa-page-header-button-icon"><use href="#sa-icon-notifications"></use></svg>',
            '<tpl if="showNotificationsBadge">',
                '<span class="sa-page-header-notifications-button-badge" aria-label="{notificationsBadgeCount} new notifications">{notificationsBadgeCount}</span>',
            '</tpl>',
        '</button>',
        '<div class="sa-page-header-separator" aria-hidden="true"></div>',
        '<button type="button" class="sa-page-header-button sa-page-header-support-button<tpl if="chatAvailable"> sa-page-header-support-button-live-chat</tpl>" aria-label="Live Chat" aria-expanded="false">',
            '<span class="sa-page-header-support-button-chat-badge">LIVE CHAT!</span>',
            '<svg aria-hidden="true" class="sa-page-header-button-icon"><use href="#sa-icon-support"></use></svg>',
            'Support',
        '</button>',
        '<div class="sa-page-header-separator" aria-hidden="true"></div>',
        '<button type="button" class="sa-page-header-button sa-page-header-username-button" aria-label="Account options for {username:htmlEncode}" aria-expanded="false">',
            '<svg aria-hidden="true" class="sa-page-header-button-icon"><use href="#sa-icon-user"></use></svg>',
            '<span class="sa-page-header-button-text">{username:htmlEncode}</span>',
        '</button>'
    ],

    initComponent() {
        this.callParent();

        this.ifCls(!SA.userData.anonymous, 'sa-page-header-with-notifications-button');
    },

    initEvents() {
        var el = this.el;

        this.callParent();

        el.on({
            delegate: '.sa-page-header-project-name',
            scope: this,

            click: this.onProjectNameClick,
            mouseout: this.onProjectNameMouseOut,
            mouseover: this.onProjectNameMouseOver
        });

        el.on({
            delegate: '.sa-page-header-button',
            scope: this,

            mouseout: this.onButtonMouseOut,
            mouseover: this.onButtonMouseOver
        });

        el.on('click', this.onNewProjectButtonClick, this, {delegate: '.sa-page-header-new-button'});
        el.on('click', this.onOpenProjectButtonClick, this, {delegate: '.sa-page-header-open-button'});
        el.on('click', this.onManageProjectButtonClick, this, {delegate: '.sa-page-header-manage-button'});
        el.on('click', this.onSupportButtonClick, this, {delegate: '.sa-page-header-support-button'});
        el.on('click', this.onUsernameButtonClick, this, {delegate: '.sa-page-header-username-button'});

        setTimeout(() => this.refresh(), 10);

        SA.Olark.onAvailabilityChange(() => this.refreshChatBadge());
    },

    onButtonMouseOut(ev, target) {
        Ext.fly(target).removeCls('sa-page-header-button-over');
    },

    onButtonMouseOver(ev, target) {
        if (Ext.fly(ev.target).hasCls('sa-page-header-support-button-chat-badge')) {
            return;
        }

        Ext.fly(target).addCls('sa-page-header-button-over');
    },

    onManageProjectButtonClick() {
        SA.AppController.showProjectView(this.project);
    },

    onNewProjectButtonClick() {
        Ext.createByAlias('controller.new-project-controller');
    },

    onOpenProjectButtonClick(ev, target) {
        var menu = this.openProjectMenu;

        if (menu && menu.wasRecentlyVisible()) {
            return;
        }

        menu = this.openProjectMenu = Ext.widget({
            xtype: 'open-project-menu',
            track: true,

            plugins: [{
                ptype: 'sa-arrow',
                bias: 0.2
            }]
        });

        this.showMenuAtTarget(menu, target);
    },

    onProjectNameClick(ev, target) {
        var project = this.project;

        if (this.renameMenu && this.renameMenu.wasRecentlyVisible()) {
            return;
        }

        this.renameMenu = Ext.widget({
            xtype: 'rename-menu',

            maxLength: 40,
            name: project.getName(),
            positionEl: target,
            target: this,
            track: true,

            handler(name) {
                project.setName(name);
                project.save();
            }
        });
    },

    onProjectNameMouseOut(ev, el) {
        Ext.fly(el).removeCls('sa-page-header-project-name-over');
    },

    onProjectNameMouseOver(ev, el) {
        Ext.fly(el).addCls('sa-page-header-project-name-over');
    },

    onSupportButtonClick(ev, target) {
        var menu = this.supportMenu = (this.supportMenu || createMenu());

        if (Ext.fly(ev.target).hasCls('sa-page-header-support-button-chat-badge')) {
            SA.Olark.openChat();

            return;
        }

        if (menu.wasRecentlyVisible()) {
            return;
        }

        this.showMenuAtTarget(menu, target);

        function createMenu() {
            return Ext.widget({
                xtype: 'support-menu',
                track: true,

                plugins: [{
                    ptype: 'sa-arrow',
                    bias: 0.2
                }]
            });
        }
    },

    onUsernameButtonClick(ev, target) {
        var hasImports = SA.data.UserDatasets.hasDatasets(),
            menu = this.usernameMenu = (this.usernameMenu || createMenu()),
            manageImportsItem = menu.items.findBy(({itemId}) => itemId === 'manageImportsItem');

        if (menu.wasRecentlyVisible()) {
            return;
        }

        manageImportsItem.setEnabled(hasImports);

        this.showMenuAtTarget(menu, target);

        function createMenu() {
            var showAccountItems = !SA.User.isGuest() && !SA.Institution.hasLibraryCardAuthentication(),
                apiKeyWindow;

            if (SA.User.getCanAuthenticateByKey()) {
                apiKeyWindow = document.createElement('sa-api-key-window');
                document.body.appendChild(apiKeyWindow);
            }

            return Ext.widget({
                xtype: 'menu',
                track: true,

                items: [
                    {
                        text: 'Change Email Address…',
                        hidden: !showAccountItems,

                        handler() {
                            Ext.widget({xtype: 'change-email-window'});
                        }
                    }, {
                        text: 'Change Password…',
                        hidden: !showAccountItems,

                        handler() {
                            Ext.widget({xtype: 'change-password-window'});
                        }
                    }, {
                        xtype: 'menuseparator',
                        hidden: !showAccountItems
                    }, {
                        text: 'Import Data…',

                        handler() {
                            Ext.createByAlias('controller.import-terms-controller');
                        }
                    }, {
                        text: 'Manage Imported Data',
                        itemId: 'manageImportsItem',

                        handler() {
                            Ext.createByAlias('controller.manage-imports-controller');
                        }
                    }, {
                        text: 'Generate Key',
                        hidden: !SA.User.getCanAuthenticateByKey(),

                        handler() {
                            apiKeyWindow?.open();
                        }
                    }, {
                        xtype: 'menuseparator'
                    }, {
                        text: 'Sign Out',

                        handler() {
                            SA.logout();
                        }
                    }
                ],

                plugins: [{
                    ptype: 'sa-arrow',
                    bias: 0.2
                }]
            });
        }
    },

    refresh() {
        var notificationsBadgeCount = this.getNotificationsBadgeCount?.() ?? 0,
            showNotificationsBadge = notificationsBadgeCount > 0;

        this.update({
            id: this.id,
            showNotificationsBadge,
            notificationsBadgeCount,
            chatAvailable: SA.Olark.isAvailable(),
            manageActive: this.manageActive,
            projectName: this.project?.getName() ?? 'Loading…',
            username: SA.model.User.getScreenName()
        });
    },

    refreshChatBadge() {
        var chatAvailable = SA.Olark.isAvailable(),
            supportBtn = this.el.query('.sa-page-header-support-button')[0];

        Ext.fly(supportBtn).ifCls(chatAvailable, 'sa-page-header-support-button-live-chat');
    },

    set({model: view, mode}) {
        var project = view.getProject();

        this.project = project;

        this.manageActive = view === project && mode === 'view';

        Ext.destroy(this.projectNameChangeListener);

        this.projectNameChangeListener = project.on('change:name', this.refresh, this, {destroyable: true});

        this.refresh();
    },

    setView(model) {
        this.set({model, mode: null}); 
    },

    showMenuAtTarget(menu, target) {
        target.setAttribute('aria-expanded', 'true');
        Ext.fly(target).addCls('sa-page-header-button-active');

        menu.on('hide', onHide, null, {single: true});
        menu.getPlugin('sa-arrow').setTarget(target);
        menu.showBy(target, 'tl-bl?', [0, 7]);

        function onHide() {
            target.setAttribute('aria-expanded', 'false');
            Ext.fly(target).removeCls('sa-page-header-button-active');
        }
    }
});

